import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { AccountingService } from '../accounting.service';
import { ModalPrintComponent } from '../modal-print/modal-print.component';
import { ModalCancelComponent } from '../modal-cancel/modal-cancel.component';

@Component({
  selector: 'app-create-receipt-from-invoice',
  templateUrl: './create-receipt-from-invoice.component.html',
  styleUrls: ['./create-receipt-from-invoice.component.scss']
})
export class CreateReceiptInvoiceComponent implements OnInit {

  isLoading: boolean = false;
  isEdit: boolean = false;

  id: string;
  receiptForm: FormGroup;
  createType: string = '';
  tax: boolean = false;
  vat: boolean = false;
  receiptDetail: any;
  date: any;
  hasChange: boolean = false;
  isPrint: boolean = false;
  printData: any;
  printDetail: any;
  canPrint: boolean = false;
  invoiceType: string = '';
  title: string = '';

  // for abbreviated receipt
  total: number = 0;
  discount: number = 0;
  priceWithoutVat: number = 0;
  taxPrice: number = 0;
  vatPrice: number = 0;
  totalNetPrice: number = 0;

  // for full receipt
  total2: number = 0;
  discount2: number = 0;
  priceWithoutVat2: number = 0;
  taxPrice2: number = 0;
  vatPrice2: number = 0;
  totalNetPrice2: number = 0;

  printType: string = '';

  column = [
    { header: 'เลขที่', class: 'col-1' },
    { header: 'รายการ', class: 'col-4' },
    { header: 'จำนวน', class: 'col-1' },
    { header: 'ราคาต่อหน่วย', class: 'col-2' },
    { header: 'ส่วนลด', class: 'col-1' },
    { header: 'จำนวนเงิน', class: 'col-2' },
    { header: '', class: 'col-1' },
  ];

  formatterPrice = (value: number): string =>
    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  constructor(
    private fb: FormBuilder,
    private gobalFunctionService: GobalFunctionService,
    public matDialog: MatDialog,
    private accountService: AccountingService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.id = new URL(location.href).searchParams.get('id');

    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));

    this.title = this.isEdit ? `ใบเสร็จ ${this.id}` : 'สร้างใบเสร็จ';
    this.gobalFunctionService.setTitle(this.title);

    if (this.isEdit) {
      this.createType = new URL(location.href).searchParams.get('type');
      this.printType = new URL(location.href).searchParams.get('type');
      // console.log(this.createType);

      this.getDetailReceipt(this.id);
    } else {
      this.createType = 'Short';
      this.getDetailFromInvoice(this.id);
    }
  }

  getDetailFromInvoice(id) {
    this.isLoading = true;

    this.accountService.getDetailInvoice(id).pipe(
      map(inv => {
        // console.log(inv.result);
        this.receiptDetail = inv.result;
        this.invoiceType = this.receiptDetail.CREATE_TYPE;
        this.change(this.createType);
      }),
      catchError(err => {
        alert(err.error.message);
        return of(null);
      })
    ).subscribe();
  }

  getDetailReceipt(id) {
    let body = {
      RECEIPT_NO: id
    }

    this.accountService.getDetailReceipt(body).pipe(
      map(receipt => {
        // console.log(receipt.result);
        this.receiptDetail = receipt.result;
        this.createType = this.receiptDetail.RECEIPT_TYPE;
        this.invoiceType = this.receiptDetail.CREATE_TYPE;
        this.change(this.createType);
      }),
      catchError(err => {
        alert(err.error.message);
        return of(null);
      })
    ).subscribe();
  }

  change(type) {
    this.isLoading = true;
    this.createType = type;
    let today = new Date();
    let date = this.isEdit ? new Date(this.receiptDetail.CREATE_DATE) : today;
    let note = this.isEdit ? this.receiptDetail.REMARK : '';
    let billedAmount = this.isEdit ? this.receiptDetail.BILLED_AMOUNT : this.receiptDetail.BILLED_AMOUNT;

    // console.log(type);

    let shortForm = {
      note: [note],
      date: [date, Validators.required],
      lists: this.fb.array([]),
    }
    let fullForm = {
      name: [this.receiptDetail.CUSTOMER_NAME, Validators.required],
      detail: [this.receiptDetail.CUSTOMER_DETAIL, Validators.required],
      title: [this.receiptDetail.TITLE, Validators.required],
      taxId: [this.receiptDetail.TAX_NO, [Validators.required, Validators.pattern("([0-9]{13}$)")]],
      ...shortForm,
    }
    let partialShortForm = {
      ...shortForm,
      total: [billedAmount, Validators.required],
    }
    let partialFullForm = {
      ...fullForm,
      total: [billedAmount, Validators.required],
    }

    if (this.invoiceType === 'Partial') {
      switch (type) {
        case 'Full': {
          this.receiptForm = this.fb.group(partialFullForm);
          break;
        }
        case 'Short': {
          this.receiptForm = this.fb.group(partialShortForm);
          this.date = date;
          break;
        }
      }
    } else {
      switch (type) {
        case 'Full': {
          this.receiptForm = this.fb.group(fullForm);
          break;
        }
        case 'Short': {
          this.receiptForm = this.fb.group(shortForm);
          this.date = date;
          break;
        }
      }
    }

    // console.log(this.receiptForm);

    if (this.receiptForm.value.lists.length === 0) { this.addGroup(type); }

    if (this.isPrint) {
      this.printPdf(this.printData);
    }
    this.onCreateGroupFormValueChange();

    setTimeout(() => {
      this.isLoading = false;
    }, 500)

  }

  addGroup(type) {
    let receipt = this.isEdit ? this.receiptDetail.reDetail : this.receiptDetail.invDetail;
    // receipt = this.isPrint ? this.receiptDetail.reDetail : this.receiptDetail.invDetail;

    receipt.forEach(e => {
      (<FormArray>this.receiptForm.get("lists")).push(this.fb.group({
        list: [e.DESCRIPTION, [Validators.required]],
        number: [e.QTY, [Validators.required]],
        unitPrice: [e.UNIT_PRICE, [Validators.required]],
        discount: [e.DISCOUNT, [Validators.required]],
        totalWithoutDiscount: [e.UNIT_PRICE * e.QTY, Validators.required],
        total: [e.TOTAL],
      }));
    });
    this.vat = this.receiptDetail.INCLUDE_VAT === 1 ? true : false;
    if (type === 'Short') {
      this.getSummaryAbbreviated(this.receiptFormArray);
      // if (this.receiptDetail.INCLUDE_VAT === 1) {
      //   this.calNetPriceAbbreviated();
      // }
    } else if (type === 'Full') {
      this.getSummaryFullReceipt(this.receiptFormArray);
      // if (this.receiptDetail.INCLUDE_VAT === 1) {
      //   this.calNetPriceFullReceipt();
      // }
    }
  }

  get receiptFormArray(): FormArray {
    return this.receiptForm.get('lists') as FormArray;
  }

  selectDate(e, form) {
    // console.log(e);

    form.patchValue({
      date: e,
      // dateEnd: e[1]
    });
    form.get('date').updateValueAndValidity();
    // form.get('dateEnd').updateValueAndValidity();
  }

  removeGroup(i, form) {
    (<FormArray>form.get("lists")).removeAt(i);

    if (this.createType === 'Short') {
      this.getSummaryAbbreviated(this.receiptFormArray);
    } else {
      this.getSummaryFullReceipt(this.receiptFormArray);
    }
    // this.get
  }

  detectNumber(e, formcontrol) {
    if (e < 0) {
      // this.evidenceForm.controls['TRANFER_HR'].setValue(0);
      formcontrol.setValue(0);
      // formcontrol.setErrors({'incorrect': true});
    }
  }

  getTotal(form, i) {
    let number = form.value[i].number;
    let unitPrice = form.value[i].unitPrice;
    let discount = form.value[i].discount;
    let total = (unitPrice * number) - discount;
    let totalWithoutDiscount = unitPrice * number;

    form.at(i).patchValue({
      total: total,
      totalWithoutDiscount: totalWithoutDiscount
    })
    // console.log(form)
  }

  getSummaryAbbreviated(form) {
    let priceWithoutVat = 0;
    let unitPrice = 0;
    let discount = 0;
    let totalWithoutDiscount = 0;
    let vatPrice = 0;
    let totalNetPrice = 0;

    form.value.forEach((e, i) => {
      unitPrice = unitPrice + e.unitPrice;
      discount = discount + e.discount;
      totalWithoutDiscount = totalWithoutDiscount + e.totalWithoutDiscount;
      priceWithoutVat = priceWithoutVat + e.total;
    });

    this.total = totalWithoutDiscount;
    this.discount = discount
    this.priceWithoutVat = priceWithoutVat;

    if (this.vat) {
      vatPrice = (priceWithoutVat * 7) / 100;
      totalNetPrice = priceWithoutVat + vatPrice;
    } else {
      totalNetPrice = priceWithoutVat;
      vatPrice = 0;
      // console.log(totalNetPrice);
    }

    this.totalNetPrice = totalNetPrice;
    this.vatPrice = vatPrice;
    // console.log(totalNetPrice);
  }

  calNetPriceAbbreviated() {
    if (this.vat) {
      this.vatPrice = (this.priceWithoutVat * 7) / 100;
      this.totalNetPrice = this.totalNetPrice + this.vatPrice;
    } else {
      this.totalNetPrice = this.priceWithoutVat;
      this.vatPrice = 0;
    }
    // console.log(this.totalNetPrice);

  }

  getSummaryFullReceipt(form) {
    let priceWithoutVat = 0;
    let unitPrice = 0;
    let discount = 0;
    let totalWithoutDiscount = 0
    let vatPrice = 0;
    let totalNetPrice = 0;

    form.value.forEach((e, i) => {
      unitPrice = unitPrice + e.unitPrice;
      discount = discount + e.discount;
      totalWithoutDiscount = totalWithoutDiscount + e.totalWithoutDiscount;
      priceWithoutVat = priceWithoutVat + e.total;
    });

    this.total2 = totalWithoutDiscount;
    this.discount2 = discount
    this.priceWithoutVat2 = priceWithoutVat;

    if (this.vat) {
      vatPrice = (priceWithoutVat * 7) / 100;
      totalNetPrice = priceWithoutVat + vatPrice;
    } else {
      totalNetPrice = priceWithoutVat;
      vatPrice = 0;
    }
    this.totalNetPrice2 = totalNetPrice;
    this.vatPrice2 = vatPrice;
  }

  calNetPriceFullReceipt() {
    if (this.vat) {
      this.vatPrice2 = (this.priceWithoutVat2 * 7) / 100;
      this.totalNetPrice2 = this.totalNetPrice2 + this.vatPrice2;
    } else {
      this.totalNetPrice2 = this.priceWithoutVat2;
      this.vatPrice2 = 0;
    }
  }

  onCreateGroupFormValueChange() {
    const initialValue = this.receiptForm.value;
    this.receiptForm.valueChanges.subscribe(value => {
      this.hasChange = Object.keys(initialValue).some(key => this.receiptForm.value[key] !== initialValue[key]);
    });

    // console.log(this.hasChange);

  }

  saveFullReceipt(form) {
    this.isLoading = true;
    let item = [];

    form.lists.forEach((e, i) => {
      item.push({
        ITEM_NUM: i + 1,
        DESCRIPTION: e.list,
        QTY: e.number,
        UNIT_PRICE: e.unitPrice,
        DISCOUNT: e.discount,
        TOTAL: e.total,
      })
    });

    let body = {
      INVOICE_NO: this.receiptDetail.INVOICE_NO,
      TITLE: this.receiptDetail.TITLE,
      CUSTOMER_NAME: this.receiptDetail.CUSTOMER_NAME,
      CUSTOMER_DETAIL: this.receiptDetail.CUSTOMER_DETAIL,
      TAX_NO: this.receiptDetail.TAX_NO,
      CUSTOMER_TYPE: 'บริษัท',
      CREATE_DATE: form.date,
      ACCOUNTING_ID: this.receiptDetail.ACCOUNTING_ID,
      ACCOUNTING_NAME: this.receiptDetail.ACCOUNTING_NAME,
      ITEMS: item,
      REMARK: form.note,
      INCLUDE_VAT: this.vat,
      VAT_PRICE: this.vatPrice2,
      TOTAL: this.total2,
      DISCOUNT: this.discount2,
      BEFORE_VAT: this.priceWithoutVat2,
      GRAND_TOTAL: this.totalNetPrice2,
      BILLED_AMOUNT: this.receiptDetail.BILLED_AMOUNT,
    };

    const dialogSaveConfig = new MatDialogConfig();
    dialogSaveConfig.disableClose = true;
    dialogSaveConfig.id = 'modalConfirm';
    // dialogConfig.width = '650px';
    dialogSaveConfig.autoFocus = false;
    dialogSaveConfig.data = {
      title: 'บันทึกใบเสร็จ',
      actionBtnText: 'บันทึก',
      cancleBtnText: 'ยกเลิก',
      description: `<h5 class="m-4">ต้องการบันทึกใบเสร็จใช่หรือไม่?</h5>`
    }
    const modalSave = this.matDialog.open(ModalComponent, dialogSaveConfig);
    return modalSave.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.accountService.createFullReceipt(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกใบเสร็จสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      if (!this.isPrint) {
                        this.isLoading = false;
                        window.open('accounting?type=receipt', '_self');
                        // window.opener.location.reload();
                        // setTimeout(() => {
                        //   window.close();
                        // }, 100);
                      } else {
                        this.id = res1.result.RECEIPT_NO;
                        this.getDetailReceipt(this.id);
                      }
                    }
                  })
                )
              }

            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError(err => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();

  }

  saveShortReceipt(form) {
    this.isLoading = true;
    let item = [];

    form.lists.forEach((e, i) => {
      item.push({
        ITEM_NUM: i + 1,
        DESCRIPTION: e.list,
        QTY: e.number,
        UNIT_PRICE: e.unitPrice,
        DISCOUNT: e.discount,
        TOTAL: e.total,
      })
    });

    let body = {
      INVOICE_NO: this.receiptDetail.INVOICE_NO,
      CUSTOMER_NAME: this.receiptDetail.CUSTOMER_NAME,
      CUSTOMER_DETAIL: this.receiptDetail.CUSTOMER_DETAIL,
      TAX_NO: this.receiptDetail.TAX_NO,
      CUSTOMER_TYPE: 'บริษัท',
      CREATE_DATE: form.date,
      ACCOUNTING_ID: this.receiptDetail.ACCOUNTING_ID,
      ACCOUNTING_NAME: this.receiptDetail.ACCOUNTING_NAME,
      ITEMS: item,
      REMARK: form.note,
      INCLUDE_VAT: this.vat,
      VAT_PRICE: this.vatPrice,
      TOTAL: this.total,
      DISCOUNT: this.discount,
      BEFORE_VAT: this.priceWithoutVat,
      GRAND_TOTAL: this.totalNetPrice,
      BILLED_AMOUNT: this.receiptDetail.BILLED_AMOUNT,
    }

    // console.log(body);

    const dialogSaveConfig = new MatDialogConfig();
    dialogSaveConfig.disableClose = true;
    dialogSaveConfig.id = 'modalConfirm';
    // dialogConfig.width = '650px';
    dialogSaveConfig.autoFocus = false;
    dialogSaveConfig.data = {
      title: 'บันทึกใบเสร็จ',
      actionBtnText: 'บันทึก',
      cancleBtnText: 'ยกเลิก',
      description: `<h5 class="m-4">ต้องการบันทึกใบเสร็จใช่หรือไม่?</h5>`
    }
    const modalSave = this.matDialog.open(ModalComponent, dialogSaveConfig);
    return modalSave.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.accountService.createCumulativeReceipt(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกใบเสร็จสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      if (!this.isPrint) {
                        this.isLoading = false;
                        window.open('accounting?type=receipt', '_self');
                        // window.opener.location.reload();
                        // setTimeout(() => {
                        //   window.close();

                        // }, 100);
                      } else {
                        this.id = res1.result.RECEIPT_NO;
                        this.getDetailReceipt(this.id);
                      }
                    }
                  })
                )
              }

            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError(err => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();

  }

  cancel(id) {
    let body;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      id: id,
      type: 'receipt'
    }
    const modal = this.matDialog.open(ModalCancelComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          // console.log(res);
          body = {
            RECEIPT_NO: id,
            CANCEL_REMARK: res.value,
          }

          return this.accountService.cancelReceipt(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ยกเลิกใบเสร็จสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      this.isLoading = false;
                      window.open('accounting?type=receipt', '_self');
                      // window.opener.location.reload();
                      // setTimeout(() => {
                      //   window.close()
                      // }, 100);
                    }
                  })
                )
              }
            })
          )
        } else {
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/'])
        return of(false);
      })
    ).subscribe();
  }

  print(form) {
    this.isLoading = true;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '400px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      type: 'receipt',
    };

    const modal = this.matDialog.open(ModalPrintComponent, dialogConfig);
    return modal.afterClosed().pipe(
      map(print => {
        if (print.status) {
          this.isPrint = true;
          this.printData = print;

          if (!this.isEdit) {
            this.isEdit = true;

            switch (this.createType) {
              case 'Short': { this.saveShortReceipt(form); break; }
              case 'Full': { this.saveFullReceipt(form); break; }
            }
            // this.save(form);
          } else {
            if (this.receiptDetail.STATUS === 'Done' && !this.hasChange) {
              this.printPdf(this.printData);

            } else {
              // this.updatereceipt(form);
              switch (this.createType) {
                case 'Short': { this.saveShortReceipt(form); break; }
                case 'Full': { this.saveFullReceipt(form); break; }
              }
            }
          }

        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError(err => {
        this.isLoading = false;
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  printPdf(print) {
    let total = 0,
      discount = 0,
      priceWithoutVat = 0,
      vatPrice = 0,
      totalNetPrice = 0;

    this.receiptDetail.reDetail.forEach(e => {
      total = total + (e.TOTAL + e.DISCOUNT);
      discount = discount + e.DISCOUNT;
      priceWithoutVat = priceWithoutVat + e.TOTAL;
    });

    if (this.vat) {
      vatPrice = (priceWithoutVat * 7) / 100;
      totalNetPrice = priceWithoutVat + vatPrice;

    } else {
      totalNetPrice = priceWithoutVat;
      vatPrice = 0;
    }

    let data = {
      detail: this.receiptDetail,
      price: {
        total: total,
        discount: discount,
        priceWithoutVat: priceWithoutVat,
        vatPrice: vatPrice,
        totalNetPrice: totalNetPrice,
      },
      type: 'receipt',
      note: this.receiptForm.value.note,
    }
    this.printDetail = {
      printType: print.printType,
      titleType: print.titleType,
      printData: data,
    }
    this.canPrint = true;
    // console.log(this.printDetail);

    setTimeout(() => {
      this.isPrint = false;
      this.canPrint = false;
      this.isLoading = false;

      if ((this.isEdit && this.hasChange) || !this.isEdit) {
        window.open(`/accounting/create-receipt-from-invoice?isEdit=true&id=${this.id}&type=${this.createType}`, '_self');
      }

    }, 1000);
    // console.log(print);
  }

  close() {
    window.close();
  }

}
